import { defineMessages } from 'react-intl';

const headerTypes = [
  { name: 'Standard', value: 'Standard', labelId: 'STANDARD' },
  { name: 'Bottom', value: 'Bottom', labelId: 'BOTTOM' },
  { name: 'Label', value: 'Label', labelId: 'LABEL' },
  { name: 'None', value: 'None', labelId: 'NONE' },
];

const controlsList = [{
  name: 'name',
  labelId: 'HEADER_TITLE',
  type: 'text',
  default: 'My Chart',
}, {
  name: 'headerType',
  labelId: 'HEADER_TYPE',
  type: 'select',
  default: 'Standard',
  options: headerTypes,
}, {
  name: 'cardHeaderFontSize',
  labelId: 'HEADER_FONT_SIZE',
  type: 'slider',
  default: 14,
  options: {
    min: 10,
    max: 24,
    step: 0.5,
  },
}];

const messages = defineMessages({
  HEADER: {
    id: 'HEADER',
    defaultMessage: 'Header',
  },
  HEADER_TITLE: {
    id: 'HEADER_TITLE',
    defaultMessage: 'Header Title',
  },
  HEADER_TYPE: {
    id: 'HEADER_TYPE',
    defaultMessage: 'Header Type',
  },
  HEADER_FONT_SIZE: {
    id: 'HEADER_FONT_SIZE',
    defaultMessage: 'Header Font Size',
  },
  STANDARD: {
    id: 'STANDARD',
    defaultMessage: 'Standard',
  },
  BOTTOM: {
    id: 'BOTTOM',
    defaultMessage: 'Bottom',
  },
  LABEL: {
    id: 'LABEL',
    defaultMessage: 'Label',
  },
  NONE: {
    id: 'NONE',
    defaultMessage: 'None',
  },
});

// controls by group, used to present controls in like groups
const controlsGroups = [{
  labelId: 'HEADER',
  controls: controlsList,
}];

function BaseStyleControls({ renderControlGroup }) {
  return controlsGroups.map(
    (controlsGroup, cgIndex) => renderControlGroup(controlsGroup, messages, cgIndex),
  );
}

export default BaseStyleControls;
